
<ValidationProvider v-slot="{ errors, valid }" :vid="vid" :name="$attrs.name || $attrs.label" :rules="rules">
  <b-field :horizontal="horizontal" v-bind="$attrs" :type="{ 'is-danger': errors[0], 'is-success': verified }" :custom-class="verified ? 'is-verified' : ''">
    <b-input v-model="innerValue" v-bind="$attrs"></b-input>
  </b-field>
  <p class="help is-danger">{{ errors[0] }}</p>
</ValidationProvider>
